//
//
//
//
//
//

export default {
  name: 'm-timer-tip',
  computed: {
    timerTip () {
      if (this.$store.state.order.countdownTimer <= 0) {
        return '支付逾期订单已取消，请重新下单'
      }
      return '请在<span>' + this.$store.getters.formatCountdownTimer.minute + '</span>分<span>' + this.$store.getters.formatCountdownTimer.second + '</span>秒' + '内完成支付，逾期订单将自动取消'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/TimerTip.vue